import { render } from "./user-list-modal.vue?vue&type=template&id=b80715e0"
import script from "./user-list-modal.vue?vue&type=script&lang=js"
export * from "./user-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__